<script>
  import { onMount } from 'svelte';
  import { MDCDialog } from '@material/dialog';
  import { TS } from '../../config/translation-keys.js';
  import { t9n } from '../../lib/translate.js';
  import session from '../../lib/session';
  import { APIClient } from '../../state-charts';
  import { show_message } from '../../lib/flash.ts';

  import InputField from '../../lib/components/InputField.svelte';
  import Dialog from '../../lib/components/Dialog.svelte';

  export let amount;
  export let product_amount = null;
  export let product_orderer_price = null;

  let btn_disabled = true;

  let form_data = {
    name: null,
    email: null,
    address: null,
    city: null,
    postal_code: null,
    billing_email: null,
    business_id: null,
    e_invoice_address: null,
    e_invoice_operator: null,
    invoice_reference: null,
    product_amount: product_amount,
    product_orderer_price: product_orderer_price,
  };

  let tooltip = t9n(TS.PILOT_POINTS_UI_EXPLANATION);

  const get_confirmation_text = () => {
    let supplement = $session.merchant.billing_supplement;
    let currency_sign = $session.merchant.currency_sign;
    let price = amount / $session.merchant.pilot_points_multiplier;
    if (!!supplement) {
      let total = price + supplement;
      return t9n(
        TS.PILOT_POINTS_DIALOG_AMOUNT_SUPPLEMENT,
        amount,
        price,
        currency_sign,
        supplement,
        currency_sign,
        total,
        currency_sign
      );
    } else {
      return t9n(TS.PILOT_POINTS_DIALOG_AMOUNT, amount, price, currency_sign);
    }
  };

  const load_last_billing_request = async () => {
    let result = await APIClient.last_billing_request();
    if (result?.last) form_data = result.last;
  };

  const ask_for_billing = async () => {
    let data = form_data;
    data.amount = amount;
    data.product_amount = product_amount;
    data.product_orderer_price = product_orderer_price;

    let result = await APIClient.post_billing_request(data);
    if (result) {
      amount = null;
      form_data = {
        name: null,
        email: null,
        address: null,
        city: null,
        postal_code: null,
        billing_email: null,
        business_id: null,
        e_invoice_address: null,
        e_invoice_operator: null,
        invoice_reference: null,
        product_amount: product_amount,
        product_orderer_price: product_orderer_price,
      };
      show_message(t9n(TS.PILOT_POINTS_SUCCESS_MESSAGE), 'success');
    }
  };

  const open_dialog = () => {
    let target = document.querySelector('.ask-billing-dialog');
    target.innerHTML = '';

    let dialog = new Dialog({
      target: target,
      props: {
        id: 'dialog-billing',
        title: t9n(TS.PILOT_POINTS_BUY_CONFIRM_TITLE),
        content: get_confirmation_text(),
        buttons: [
          {
            label: t9n(TS.ORDERER_TEAMS_CLOSE_LABEL),
            action: () => {
              dialog.close();
            },
            classes: [],
          },
          {
            label: t9n(TS.REG_FORM_OK),
            action: async () => {
              await ask_for_billing();
              dialog.close();
            },
            classes: [],
          },
        ],
      },
    });
    dialog.open();
  };

  const validate_form = () => {
    btn_disabled = true;

    if (
      !!amount &&
      form_data.name &&
      form_data.email &&
      form_data.address &&
      form_data.city &&
      form_data.postal_code
    ) {
      if (!!form_data.billing_email) {
        btn_disabled = false;
      } else {
        if (
          !!form_data.business_id &&
          !!form_data.e_invoice_address &&
          !!form_data.e_invoice_operator &&
          !!form_data.invoice_reference
        ) {
          btn_disabled = false;
        }
      }
    }
  };

  $: if (form_data) validate_form();

  onMount(async () => {
    await load_last_billing_request();
  });
</script>

<div class="content">
  <div style="margin-top: -35px;">
    <h4>{t9n(TS.PILOT_POINTS_BASIC_INFORMATION)}</h4>
    <div class="flex" data-tooltip={tooltip}>
      <!--      <div class='responsive-input'>-->
      <!--        <InputField-->
      <!--          id="billing_amount"-->
      <!--          type="number"-->
      <!--          label={t9n(TS.SHARED_ORDER_AMOUNT_LABEL)}-->
      <!--          name="amount"-->
      <!--          is_required={true}-->
      <!--          bind:value={form_data.amount} />-->
      <!--      </div>-->

      <div class="responsive-input">

        <InputField
          id="billing_name"
          type="text"
          label={t9n(TS.ORDER_NAME)}
          name="name"
          is_required={true}
          bind:value={form_data.name}
          is_tooltip_default={false}
          width="inherit" />
      </div>

      <div class="responsive-input">
        <InputField
          id="billing_email"
          type="email"
          label={t9n(TS.PROFILE_EMAIL_LABEL)}
          name="email"
          is_required={true}
          bind:value={form_data.email}
          is_tooltip_default={false}
          width="inherit" />
      </div>

      <div class="responsive-input">
        <InputField
          id="billing_address"
          type="text"
          label={t9n(TS.NEW_ORDER_LOC_PRM_ADDR)}
          name="address"
          is_required={true}
          bind:value={form_data.address}
          is_tooltip_default={false}
          width="inherit" />
      </div>

      <div class="responsive-input">
        <InputField
          id="billing_city"
          type="text"
          label={t9n(TS.NEW_ORDER_LOC_CITY)}
          name="city"
          is_required={true}
          bind:value={form_data.city}
          is_tooltip_default={false}
          width="inherit" />
      </div>

      <div class="responsive-input">
        <InputField
          id="billing_postal_code"
          type="text"
          label={t9n(TS.NEW_ORDER_LOC_POSTAL)}
          name="postal_code"
          is_required={true}
          bind:value={form_data.postal_code}
          is_tooltip_default={false}
          width="inherit" />
      </div>

    </div>

    <h4>{t9n(TS.NEW_ORDER_TIME_CHOOSE_OPTION)}</h4>
    <p>{t9n(TS.PILOT_POINTS_INVOICE_INFORMATION)}</p>
    <div class="flex">

      <div class="responsive-input">
        <InputField
          id="billing_business_id"
          type="text"
          label={t9n(TS.PILOT_POINTS_BUSINESS_ID)}
          name="email_business_id"
          is_required={true}
          bind:value={form_data.business_id}
          disabled={!!form_data.billing_email}
          is_tooltip_default={false}
          width="inherit" />
      </div>

      <div class="responsive-input">
        <InputField
          id="billing_e_invoice_address"
          type="text"
          label={t9n(TS.PILOT_POINTS_E_INVOICE_ADDRESS)}
          name="e_invoice_address"
          is_required={true}
          bind:value={form_data.e_invoice_address}
          disabled={!!form_data.billing_email}
          is_tooltip_default={false}
          width="inherit" />
      </div>

      <div class="responsive-input">
        <InputField
          id="billing_e_invoice_operator"
          type="text"
          label={t9n(TS.PILOT_POINTS_E_INVOICE_OPERATOR)}
          name="e_invoice_operator"
          is_required={true}
          bind:value={form_data.e_invoice_operator}
          disabled={!!form_data.billing_email}
          is_tooltip_default={false}
          width="inherit" />
      </div>

      <div class="responsive-input">
        <InputField
          id="billing_invoice_reference"
          type="text"
          label={t9n(TS.PILOT_POINTS_INVOICE_REFERENCE)}
          name="invoice_reference"
          is_required={true}
          bind:value={form_data.invoice_reference}
          disabled={!!form_data.billing_email}
          is_tooltip_default={false}
          width="inherit" />
      </div>

    </div>

    <p>{t9n(TS.PILOT_POINTS_ENTER_EMAIL)}</p>
    <div class="flex">
      <div class="responsive-input">
        <InputField
          id="billing_email_for_billing"
          type="email"
          label={t9n(TS.PILOT_POINTS_EMAIL_FOR_BILLING)}
          name="email_billing"
          is_required={true}
          bind:value={form_data.billing_email}
          is_tooltip_default={false}
          disabled={!!form_data.e_invoice_address || !!form_data.e_invoice_operator || !!form_data.invoice_reference || !!form_data.business_id}
          width="inherit" />
      </div>

      <div class="billing_submit">
        <p class="required">* {t9n(TS.REQUIRED_LABEL)}</p>
        <button
          class="mdc-button mdc-button--raised"
          disabled={btn_disabled}
          on:click|preventDefault={async () => {
            open_dialog();
          }}>
          {t9n(TS.ORDER_SUBMIT)}
        </button>
      </div>

    </div>

  </div>

  <div class="ask-billing-dialog" />
</div>

<style>
  h4,
  p {
    margin-left: 113px;
  }
  /* Tooltip
  *******************************************************/

  .tooltip-default {
    position: relative;
    font-size: 12px;
    /*top: -60px;*/
    animation: transition_in 0.6s;
  }

  .tooltip-default .tooltip-top {
    /*position: absolute;*/
    z-index: 1;
    bottom: 100%;
    right: 0;
    left: 50%;
  }

  .tooltip-default .tooltip-text {
    background-color: var(--mdc-theme-secondary);
    color: #fff;
    text-align: center;
    border-radius: 6px;
    padding: 8px 8px;
    padding-left: 30px;
    padding-right: 30px;
    font-size: 13px;
    box-shadow: 1px 1px 3px 0px rgba(0, 0, 0, 0.3);
    display: block;
  }

  .tooltip-default .tooltip-text::after {
    content: ' ';
    position: relative;
    top: 30px;
    left: -125px;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #018786 transparent transparent transparent;
  }

  .content {
    margin-bottom: 50px;
    margin-top: 60px;
    /*margin-left: 25px;*/
    justify-content: center;
    display: flex;
  }

  .required {
    font-size: 10pt;
    color: #323232;
    margin-right: 155px;
    /*position: absolute;*/
    /*left: 25px;*/
  }

  .responsive-input {
    margin-right: 20px;
  }

  .flex {
    position: relative;
  }

  .billing_submit {
    display: flex;
  }

  @media (min-width: 1025px) {
    .responsive-input {
      width: 310px;
    }

    .flex {
      /*justify-content: center;*/
      margin-left: 113px;
      display: flex;
      flex-wrap: wrap;
    }

    .billing_submit {
      position: absolute;
      left: 220px;
      top: 10px;
    }
  }

  /* Tablet Mode
    *******************************************************/

  @media (min-width: 769px) and (max-width: 1024px) {
    .responsive-input {
      width: 410px;
    }

    .flex {
      width: 410px;
      display: flex;
      flex-wrap: wrap;
    }
  }

  /* Mobile Mode
          *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    .responsive-input {
      width: 238px;
    }

    .flex {
      width: 410px;
      display: flex;
      flex-wrap: wrap;
    }
  }
</style>
